import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Arrival"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 21H22.5V22.5H1.5V21ZM12.9076 3.92244L13.9501 4.20744L14.7001 12.6749L19.1026 13.8524C19.8357 14.0256 20.3267 14.7156 20.2501 15.4649C20.1625 16.0144 19.76 16.4609 19.2226 16.6049C18.9766 16.6684 18.7185 16.6684 18.4726 16.6049L4.44757 12.8549C3.69883 12.6501 3.25415 11.8811 3.45007 11.1299L4.76257 6.25494L5.84257 6.53994L6.30007 10.4249L10.8001 11.6399L12.9076 3.92244ZM12.1574 2.27247C11.9096 2.34561 11.7169 2.54114 11.6474 2.78997L9.74993 9.80247L7.64243 9.23997L7.26743 5.84247C7.22066 5.56309 7.02048 5.33389 6.74993 5.24997L4.40243 4.60497C4.27972 4.57111 4.15013 4.57111 4.02743 4.60497C3.78148 4.6767 3.58916 4.86902 3.51743 5.11497L2.01743 10.7325C1.81823 11.4764 1.92286 12.269 2.30829 12.9358C2.69372 13.6026 3.32834 14.0888 4.07243 14.2875L18.1049 18.0375C18.8941 18.2598 19.7404 18.138 20.4348 17.7022C21.1292 17.2664 21.6069 16.5572 21.7499 15.75C21.9558 14.2327 20.986 12.8039 19.4999 12.435L16.1099 11.5275L15.3974 3.53247C15.3634 3.2301 15.1501 2.97825 14.8574 2.89497L12.5474 2.24997C12.4242 2.22006 12.2956 2.22006 12.1724 2.24997L12.1574 2.27247Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Arrival.vue"]]);
